import { IPromise, IQService } from "angular";
import { ServiceResponse } from "../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { MachineConfigurationGateway } from "../../gateway/models/machineConfiguration";
import { ProgressiveDefinition } from "../../gateway/models/progressiveDefinition";
import { CreateMachineAndConfigurationResponse } from "../../shared/models/machine";
import {
  CloneAndConversionService,
  vsName as cloneAndConversionServiceName,
} from "../../shared/services/cloneAndConversionService";
import { MachineGateway } from "../models/machine";

export const vsName = cloneAndConversionServiceName;

export interface CreateMachineAndConfigurationResponseGateway
  extends CreateMachineAndConfigurationResponse<
    MachineGateway,
    MachineConfigurationGateway
  > {}

export class CloneAndConversionServiceGateway extends CloneAndConversionService<
  MachineGateway,
  MachineConfigurationGateway
> {
  static $inject = [ServerUtilityName, "$q"];

  constructor(serverUtility: ServerUtility, $q: IQService) {
    super(serverUtility, $q);
  }

  protected override prepareConversionConfiguration(
    cloneConfiguration: MachineConfigurationGateway,
    currentConfiguration: MachineConfigurationGateway
  ): MachineConfigurationGateway {
    cloneConfiguration = {
      ...cloneConfiguration,
      ChangeType: "Conversion",
      Status: currentConfiguration.Status,
      MachineBank: currentConfiguration.MachineBank,
      MachineBankId: currentConfiguration.MachineBankId,
      Position: currentConfiguration.Position,
      WarehouseLocation: currentConfiguration.WarehouseLocation,
      SlotNumber: currentConfiguration.SlotNumber,
      Date: undefined,
    };

    return cloneConfiguration;
  }

  protected override prepareCloneConfiguration(
    cloneConfiguration: MachineConfigurationGateway
  ): MachineConfigurationGateway {
    cloneConfiguration = super.prepareCloneConfiguration(cloneConfiguration);
    cloneConfiguration.Position = undefined;
    cloneConfiguration.WarehouseLocation = undefined;
    return cloneConfiguration;
  }

  getProgressiveDefinition(
    progressiveDefinitionId?: number
  ): IPromise<ProgressiveDefinition | undefined> {
    if (progressiveDefinitionId === undefined) return this.$q.when(undefined);

    return this.serverUtility
      .getById<ServiceResponse<ProgressiveDefinition>>({
        url: `/api/machines/progressives/ProgressiveDefinition`,
        id: progressiveDefinitionId,
      })
      .then((response) => response.Result);
  }
}
